import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import Vuelidate from 'vuelidate'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueMask from 'v-mask'
import VueRouter from 'vue-router'
import vco from "v-click-outside"
import router from './router/index'

import NProgress from 'vue-nprogress'
import Snotify, { SnotifyPosition } from 'vue-snotify'
//import 'vue-snotify/styles/material.css';
import '@/design/snotify-style.css'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vSelect from "vue-select";

import "@/design/index.scss";
import VueSweetalert2 from 'vue-sweetalert2';
import store from '@/state/store'
import Swal from "sweetalert2";

import VueAnalytics from 'vue-analytics';

import VueSplide from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/splide.min.css';


import App from './App.vue'

import { initFirebaseBackend, refreshToken } from './authUtils'
import i18n from './i18n'

import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

Vue.use( VueSplide );


// const firebaseConfig = {
//   apiKey: 'AIzaSyAuieQ7YmTuC3jkGIOmvHnLOhM4T62szUY',
//   authDomain: process.env.VUE_APP_AUTHDOMAIN,
//   databaseURL: 'https://template-338d5.firebaseio.com/',
//   projectId: 'template-338d5',
//   storageBucket: process.env.VUE_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.VUE_APP_MESSAGINGSENDERID,
//   appId: process.env.VUE_APP_APPId,
//   measurementId: process.env.VUE_APP_MEASUREMENTID
// };


const options = {
  toast: {
    position: SnotifyPosition.rightTop,
    showProgressBar: false,
    icon: false,
    timeout: 4000,
    closeOnClick: true,
    pauseOnHover: true,
    maxOnScreen: 2,
    maxAtPosition: 2,
    preventDuplicates: true,
    //titleMaxLength: 110,
    //bodyMaxLength: 1110,
  }
};

Vue.component("v-select", vSelect);









initFirebaseBackend();

Vue.use(VueRouter)
Vue.use(vco)

Vue.config.productionTip = false

Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(VueMask)
Vue.use(require('vue-chartist'))
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAbvyBxmMbFhrzP9Z8moyYr6dCr-pzjhBE',
    libraries: 'places',
  },
  installComponents: true
})

Vue.use(VueAxios, axios)
Vue.use(Snotify, options)








 
// const nprogress = new NProgress({ parent: '.nprogress-container' })
const nprogress = new NProgress()

const options2 = {
  latencyThreshold: 100, // Number of ms before progressbar starts showing, default: 100,
  router: false, // Show progressbar when navigating routes, default: true
  http: true // Show progressbar when doing Vue.http, default: true
};
Vue.use(NProgress, options2)


// AXIOS REQUESTS INTERCEPTOR
axios.interceptors.request.use((config) => {
    
    var token = sessionStorage.getItem('token')
    if (token != null) {
      config.headers.common['Authorization'] = "Bearer " + token;
    }    
    
    if (!config.url.startsWith("/api/notifications") && !config.url.startsWith("/api/auth/refresh")) {
      nprogress.set(0.6)
    }
    
    return config;
}, (error) => {
    nprogress.done();
    return Promise.reject(error);
});

// AXIOS RESPONSES INTERCEPTOR
axios.interceptors.response.use((response) => {
  nprogress.done();
  return response;
}, (error) => {

  nprogress.done();

    if (error == null || error.response == null) {
    return; 
  }

  if (error.response.status == 401) {
    return refreshToken(store).then( () => {
      error.config.headers['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      error.config.baseURL = undefined;
      return axios.request(error.config);
    }, () => {

      if(!error.response.config.url.startsWith("/api/notifications")) {

        Swal.fire("Session expirée !", "Vous serez redirigé vers la page de Login.", "warning")
        .then(() => {
          router.push({
              path:'/logout',
          });
        });
    }

    });
  }
  
  if (error.response.status == 500) {
    Vue.prototype.$snotify.error('Une erreur interne du serveur est survenue');
    return
  }

  if (error.response.status == 404) {
    Vue.prototype.$snotify.error('Ressource introuvable!');
    return
  }

  if (error.response.status == 402) {
    router.push({ name: "Paiement" });
    return
  }

  if (error.response && error.response.data) {
    return Promise.reject(error.response.data);
  } else {
    return Promise.reject('Une erreur interne du serveur est survenue')
  }
});



Vue.use(VueAnalytics, {id: 'UA-201597372-1',router});
Vue.component('apexchart', VueApexCharts)

ClassicEditor.defaultConfig = {
  toolbar: {
    items: [
      'heading',
      '|',
      'bold',
      'italic',
      '|',
      'bulletedList',
      'numberedList',
      '|',
      'insertTable',
      '|',
      'undo',
      'redo'
    ]
  },
  image: {
    toolbar: [
      'imageStyle:full',
      'imageStyle:side',
      '|',
      'imageTextAlternative'
    ]
  },
  table: {
    contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
  },
  language: 'fr'
}


new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
